module.exports = __webpack_public_path__ + "img/ic_cuf.3340c5d1.svg";